import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { appEvents } from '@/lib/events';
import {
  isOnCanonicalLoginOrigin,
  redirectToPlatformLogin,
} from '@/lib/platform-login';

/**
 * Subscribes to auth-required events from the http client and routes the
 * user to sign-in. On the canonical origin (zafroi.com) we use the local
 * /login route so React Router can preserve `from` via location state.
 * On subdomains (erp.zafroi.com, www.zafroi.com) we hard-redirect to the
 * canonical sign-in URL so the user only ever sees one login URL.
 *
 * Mounted once inside the router tree.
 */
export function AuthGuardListener() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    return appEvents.on('auth-required', () => {
      // Ignore if already on a public auth page.
      if (location.pathname.startsWith('/login') || location.pathname === '/accept-invite') {
        return;
      }
      if (!isOnCanonicalLoginOrigin()) {
        redirectToPlatformLogin();
        return;
      }
      navigate('/login', {
        state: { from: location.pathname + location.search },
        replace: true,
      });
    });
  }, [navigate, location.pathname, location.search]);

  return null;
}
